import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, withStyles } from "@material-ui/core";
import CancelAcceptForm from "../../../../../Common/CancelAcceptForm";
import t from "../../../../../../languages/pl";
import { buttonStyle } from "../../buttonGroupStyle";
import withSubordinateUser from './../../../../../HOC/withSubordinateUser';
import FrontSVG from './Front/FrontSVG';
import BackSvg from './Back/BackSvg';
import CarDamageForm from './Form/CarDamageForm';


const useStyles = theme => ({
  button: buttonStyle(theme),
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '20px',
  },
  carContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px',
  },
  images: {
    marginTop: "16px",
    background: "white",
  }
});

const CarDamage = props => {
  const { classes, damage, name, onDialogOpen, onSubmit, nonAdminUser } = props;
  const [open, setOpen] = useState(false);
  const [carDamage, setCarDamage] = useState(damage);

  useEffect(() => {
    setCarDamage(damage);
  }, [damage]);

  const handleDamageChange = areaName => {
    const damage = [...carDamage];
    const idx = damage.findIndex((item) => item.nazwa === areaName);
    damage[idx].uszkodzony = !damage[idx].uszkodzony;

    setCarDamage(damage);
  };

  const handleDamageDescriptionChange = (event, areaName) => {
    const damage = [...carDamage];
    const idx = damage.findIndex((item) => item.nazwa === areaName);
    damage[idx].opis = event.target.value;
    setCarDamage(damage);
  };

  const handleDamageImageChange = (damage) => {
    const damageArray = [...carDamage];
    const idx = damageArray.findIndex((item) => item.nazwa === damage.nazwa );
    damageArray[idx].obraz_id = damage.obraz_id;
    setCarDamage(damageArray);
    onSubmit(carDamage);
  };

  const handleDialogOpen = () => {
    setOpen(true);
    if (onDialogOpen)
      onDialogOpen();
  };

  const handleSubmit = () => {
    onSubmit(carDamage);
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        className={classes.button}
        onClick={() => handleDialogOpen()}
      >
        {t.carDamage}
      </Button>

      <Dialog
        open={open}
        fullScreen={true}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>
          {t.carDamage} {name}
        </DialogTitle>
        <DialogContent>
          <div className={classes.wrapper}>
            <div className={classes.carContainer}>
              <Typography variant="h6">
                {t.selectElementAndDescribeDamage}
              </Typography>
              <div className={classes.images}>
                <FrontSVG
                  onChange={handleDamageChange}
                  damage={carDamage}
                />
                <BackSvg
                  damage={carDamage}
                  onChange={handleDamageChange}
                />
              </div>
            </div>
            <CarDamageForm
              carDamage={carDamage}
              onDamageDescriptionChange={handleDamageDescriptionChange}
              onDamageImageChange={handleDamageImageChange}
            />
          </div>

        </DialogContent>
        <DialogActions>
          <CancelAcceptForm
            onCancel={() => setOpen(false)}
            onSubmit={handleSubmit}
            disableSubmit={nonAdminUser}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  damage: state.carsReducer.carDamage,
});

export default compose(
  withStyles(useStyles),
  withSubordinateUser,
  connect(
    mapStateToProps,
      null
  )
)(CarDamage);

CarDamage.propTypes = {
  classes: PropTypes.object,
  damage: PropTypes.array,
  name: PropTypes.string,
  onDialogOpen: PropTypes.func,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  onSubmit: PropTypes.func,
  //withSubordinateUser
  nonAdminUser: PropTypes.bool
};
